import { useEffect } from 'react';

function useAutoFetchIfSpace({
    containerRef,
    itemHeight,
    itemsCount,
    itemsData,
    pageSize,
    hasNextPage,
    fetchNextPage
}: {
    containerRef: React.RefObject<HTMLElement>,
    itemHeight: number,
    itemsCount: number,
    itemsData: any,
    pageSize: number,
    hasNextPage: boolean,
    fetchNextPage: () => void
}) {
    useEffect(() => {
        if (!containerRef.current || !hasNextPage) return;

        const containerHeight = containerRef.current.offsetHeight;
        const contentHeight = itemsCount * itemHeight;

        if (contentHeight < containerHeight) {
            // Not enough items to fill screen – fetch more!
            fetchNextPage();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [containerRef, itemsCount, pageSize, hasNextPage, fetchNextPage, itemsData]);
}

export default useAutoFetchIfSpace;
